import $ from 'jquery'
import loadGoogleMapsAPI from 'load-google-maps-api'

/* eslint-enable */

const mapConfig = {
    key: 'AIzaSyAt2Oc2-hCcoad6k4q_68zEMEDuNirkQVA'
}

const initQwebMap = function (latlongStr, zoom, infowindowContent) {

    loadGoogleMapsAPI(mapConfig).then((googleMaps) => {

        var latlongArraY = latlongStr.split(',')
        var myLat = latlongArraY[0]
        var myLong = latlongArraY[1]

        myLat = parseFloat(myLat)
        myLong = parseFloat(myLong)

        //console.log(document.getElementById('map-wrapper'))
        var map = new googleMaps.Map(document.getElementById('map-wrapper'), {
            center: {lat: myLat, lng: myLong},
            zoom: zoom
        })

        var infowindow = new googleMaps.InfoWindow({
            content: infowindowContent
        })

        var marker = new googleMaps.Marker({
            position: {lat: myLat, lng: myLong},
            animation: googleMaps.Animation.DROP,
            map: map,
            title: 'Azienda Speciale - Don Moschetta'
        })

        marker.addListener('click', function() {
            infowindow.open(map, marker)
        })

    }).catch((err) => {
        console.error(err)
    })

}

$(document).ready(function(){
    var element = document.getElementById('map-wrapper')
    if (null !== element){
        var coordinate = element.dataset.coordinate
        var zoom = 9
        var infowindowContent = element.dataset.markercontent
        initQwebMap(coordinate, zoom, infowindowContent)
    }
})



// WEBPACK FOOTER //
// ./src/components/mappa/index.js